export default __webpack_public_path__ + "static/media/right-green-check-mark.6079f3e7.svg";